import { IProductDetailProdps } from "@Components/Pages/ProductDetail";
import {
  ProductCmsNameKeys,
  ProductCmsNameValues,
} from "@Interfaces/Api/Product";
import { Box, Tab, Tabs } from "@mui/material";
import { isEmpty } from "@Services/Helper";
import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard } from "swiper/modules";
import "swiper/css";

export function getLabel(name: string) {
  switch (name) {
    case ProductCmsNameKeys.whatIsIt:
      return ProductCmsNameValues.whatIsIt;
    case ProductCmsNameKeys.whatsInIt:
      return ProductCmsNameValues.whatsInIt;
    case ProductCmsNameKeys.howToUse:
      return ProductCmsNameValues.howToUse;
    case ProductCmsNameKeys.benefits:
      return ProductCmsNameValues.benefits;
    case ProductCmsNameKeys.whatExpertHasToSay:
      return ProductCmsNameValues.whatExpertHasToSay;
    default:
      return name;
  }
}

export default function DescriptionTabs({ product }: IProductDetailProdps) {
  const cms = { ...(product?.cms as any) };
  delete cms.subTitle;
  delete cms.whatExpertsHasToSay;

  const keys = Object.keys(ProductCmsNameKeys);

  const [value, setValue] = useState(0);
  const swiperRef = useRef<any>(null);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // When tab changes, tell swiper to slide
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(value);
    }
  }, [value]);

  return (
    <Box sx={{ marginTop: "2rem" }}>
      <Tabs value={value} onChange={handleTabChange} variant="scrollable">
        {!isEmpty(cms) &&
          keys.map((item, index) => (
            <Tab
              key={item}
              id={item}
              label={getLabel(item)}
              sx={{
                textTransform: "none",
                fontSize: "1.2rem",
                fontWeight: 600,
                ...(value === index && {
                  color: "#8d6c4d",
                }),
              }}
            />
          ))}
      </Tabs>

      <Swiper
        autoHeight
        onSlideChange={(swiper) => setValue(swiper.activeIndex)}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        allowTouchMove={false}
        slidesPerView={1}
        keyboard={{ enabled: true }}
        modules={[Keyboard]}
        style={{ paddingTop: "1rem" }}
      >
        {cms &&
          !isEmpty(cms) &&
          keys.map((item, index) => (
            <SwiperSlide key={index}>
              <Box>
                <div
                  style={{
                    fontFamily: "Gotham-Book",
                    lineHeight: "1.5",
                  }}
                  dangerouslySetInnerHTML={{ __html: cms[item] }}
                />
              </Box>
            </SwiperSlide>
          ))}
      </Swiper>
    </Box>
  );
}
